module.exports = __webpack_public_path__ + "static/img/simplepay_w140.0be346d.png";